export const exportUrl = "https://xenie.xebia.in/ticket-tool/v1/";
//export const exportUrl = "http://192.168.7.105:8085/ticket-tool/v1/";
